<template>
  <div>
    <div class="header-logo">
      <div class="logo-wrap">
        <img class="logo" src="@img/logo.png" />
      </div>
      <div class="title-wrap">
        <div v-if="this.$store.getters.hostCL">
          <div class="title">长乐区城市安全生产风险管控信息平台</div>
          <div class="sub-title">ChangLe City Security production risk control information platform</div>
        </div>
        <div v-else>
          <div class="title">福州城市安全风险管控信息平台</div>
          <div class="sub-title">Fuzhou City Security risk control information platform</div>
        </div>
        <div class="info">（监管端）</div>
      </div>
    </div>
    <div class="header-user">
      <el-dropdown placement="bottom" @command="handleUserDropdownCommand">
        <span class="el-dropdown-link header-dropdown-link">
          <div style="display:flex;align-items:center">
            <i style="font-size: 18px;margin-right:5px;"
              class="el-icon-user"></i>
            {{ userInfo.username }}
            <i style="font-size: 12px;margin-left:5px"
              class="el-icon-caret-bottom"></i>
          </div>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="OperationManual">操作手册</el-dropdown-item>
          <el-dropdown-item command="ChangePassword">修改密码</el-dropdown-item>
          <el-dropdown-item command="Logout" divided>退出登录</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <div>
      <div class="nav-bar">
        <div
          :key="item.title"
          v-for="(item, index) in routesArr"
          @click="itemClick(index, item)"
          :class="currentIndex.indexOf(item.path) > -1 ? 'current-item' : ''"
          class="menu-item">
          <i v-if="item.meta.icon" style="font-size: 18px" :class="item.meta.icon"></i>
          <img v-else-if="item.meta.img" :src="item.meta.img" style="width:18px;height:20px;">
          <span style="white-space: nowrap;font-size: 12px">
            {{ item.meta.title }}
          </span>
        </div>
      </div>
    </div>
    <PasswordForm ref="passwordForm"></PasswordForm>
    <el-dialog
      :close-on-click-modal="false"
      title=""
      :visible.sync="dialogVisible"
      width="655px">
      <div style="text-align: center;">
		<!-- 浏览器版本限制 只有低版本才能自动播放语音 style="visibility: hidden;"   -->
		<!-- <audio ref="audioMp3" muted :src="require('./UJcqPw1750406869.mp3')" style="visibility: hidden;"></audio> -->
        <div @click="goEchart" class="pc" style="margin-bottom: 26px">
          电脑端或投屏展示
        </div>
        <div @click="goEchart2" class="dp">
          应急指挥大屏展示
        </div>
		<!-- <div @click="goEchart" class="dp">
		  应急指挥大屏展示
		</div> -->
      </div>
    </el-dialog>
    <el-dialog
      append-to-body
      title="操作文档"
      :visible.sync="showEchartDialog"
      width="85%">
      <Echart ref="Echart"></Echart>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="数据大屏分辨率设置"
      :visible.sync="dataVScaleDialogVisible"
      width="450px">
        <el-form label-width="120px">
          <el-form-item label="宽度：">
            <el-input-number v-model="dataVScale.width" :controls="false" :min="1" size="mini" style="width: 250px;"></el-input-number>
          </el-form-item>
          <el-form-item label="高度：">
            <el-input-number v-model="dataVScale.height" :controls="false" :min="1" size="mini" style="width: 250px;"></el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="dataVScaleDialogVisible = false">取 消</el-button>
          <el-button size="small" type="primary" @click="clGoEchart">确 定</el-button>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import PasswordForm from './PasswordForm'
import * as types from '@/vuex/types'
import Echart from '@/views/systemData/systemData.vue'
const initScale = {
  width: 1920,
  height: 1080
}

export default {
  components: {
    PasswordForm,
    Echart,
  },
  data () {
    return {
      dialogVisible: false,
      dataVScaleDialogVisible: false,
      userInfo: { company: {} },
      currentIndex: '',
      showEchartDialog: false,
      dataVScale: {...initScale}
    }
  },
  computed: {
    routesArr () {
      let routes = this.$store.getters['permission/routers']
      this.currentIndex = this.$route.path
      return routes
        .filter(item => {
          return item.isHead
        })
        .sort((a, b) => {
          return b.index - a.index
        })
    }
  },
  mounted () {
    let userInfo = this.$store.getters.userInfo
    this.userInfo = userInfo
  },
  methods: {
    itemClick (index, item) {
      if (item.name == 'dataV') {
        this.dialogVisible = true
        // this.goEchart()
      } else {
        this.$router.push(item.path)
      }
    },
    goEchart2 () {
      if (this.$store.getters.hostCL) {
        this.dataVScale = {...initScale}
        this.dataVScaleDialogVisible = true
        //  window.open(
        //   `${this.$store.getters.sysUrl.DATAV_PLATFORM_BASE_URL}/#/index?port=admin&sid=${this.$store.state.sessionId}&v=a87ff679a2f3e71d9181a67b7542122c`
        // )
      } else {
        // window.open(
        //   `http://risk-fz-datav2.zyrcsoft.com/#/dvOne?port=admin&sid=${this.$store.state.sessionId}&v=a87ff679a2f3e71d9181a67b7542122c`
        // )
        this.$message({
          type: 'warning',
          message: '正在开发中'
        })
      }
    },
    // 右上角菜单点击响应
    handleUserDropdownCommand (command) {
      switch(command){
        case 'ChangePassword': // 修改密码
          this.$refs['passwordForm'].showForm();
          break;
        case 'AccountInfo': // 账号信息
          this.$refs['InfoForm'].showForm();
          break;
        case 'Logout': // 退出登录
          this.$store.commit(types.LOGOUT);
          this.$router.replace({ name: 'login' });
          break;
        case 'OperationManual': // 操作手册
          this.showEchartDialog = true
          break;
      }
    },
    goCompanyGraph () {
      window.open(
        `${this.$store.getters.sysUrl.DATAV_PLATFORM_BASE_URL}/companyUnit.html?id=${this.$store.getters.companyId}`
      )
    },
    goEchart () {
      if (this.$store.getters.hostCL) {
        this.dataVScale = {...initScale}
        this.dataVScaleDialogVisible = true
        //  window.open(
        //   `${this.$store.getters.sysUrl.DATAV_PLATFORM_BASE_URL}/#/index?port=admin&sid=${this.$store.state.sessionId}&v=a87ff679a2f3e71d9181a67b7542122c`
        // )
      } else {
        window.open(
          `${this.$store.getters.sysUrl.DATAV_PLATFORM_BASE_URL}/#/dvOne?port=admin&sid=${this.$store.state.sessionId}&v=a87ff679a2f3e71d9181a67b7542122c`
        )
      }
    },
    clGoEchart() {
      // 这里获取播放路径
      if(this.$store.getters.hostCL){
        setTimeout(()=>{
          this.$refs.audioMp3.play()
        },3000)
      }
      window.open(
        `${this.$store.getters.sysUrl.DATAV_PLATFORM_BASE_URL}/#/index?port=admin&sid=${this.$store.state.sessionId}&v=a87ff679a2f3e71d9181a67b7542122c&width=${this.dataVScale.width}&height=${this.dataVScale.height}`
      )
      this.dataVScaleDialogVisible = false
    }
  }
}
</script>

<style scoped>
.header-logo {
  display: flex;
  margin: 16px 0 0 0;
  color: #fff;
  float: left;
}
.logo-wrap .logo {
  margin-right: 10px;
  width: 40px;
  height: 42px;
}
.title-wrap {
  display: flex;
  align-items: flex-end;
}
.title-wrap .title {
  font-size: 26px;
  font-weight: bold;
  line-height: 1;
}
.title-wrap .sub-title {
  margin-top: 4px;
  font-size: 12px;
  line-height: 1;
}
.title-wrap .info {
  font-size: 18px;
  font-weight: 500;
  line-height: 1;
}
.header-goEchart {
  margin: 20px 30px 0 0;
  /* color: #fff; */
  float: right;
  cursor: pointer;
  /* border-left: 1px solid #ccc;
    border-right: 1px solid #ccc; */
}
.header-goEchart:hover {
  /* color: rgba(255, 255, 255, .8); */
}
.header-user {
  position: relative;
  display: flex;
  align-items: center;
  margin-right: 20px;
  padding: 0 30px;
  height: 70px;
  color: #cbcfd4;
  float: right;
}
.header-user::before {
  content: '';
  position: absolute;
  left: 0;
  width: 1px;
  height: 27px;
  background: #ffffff;
}
.header-dropdown-link {
  cursor: pointer;
  color: #fff;
}
.header-dropdown-link:hover {
  color: #fff;
}
.header-dropdown-link div {
  height: 30px;
}
.nav-bar {
  height: 70px;
  display: flex;
  align-items: center;
  color: #fff;
  padding-left: 15px;
  /* float: right; */
  flex-direction: row-reverse;
  padding-right: 20px;
}

.menu-item {
  cursor: pointer;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 20px;
  height: 70px;
  background-color: #5190fb;
}
.current-item {
  color: #fff;
  background: #4472c3;
  /* border-bottom: 4px solid #ffa58f; */
  position: relative;
}
/* .current-item::before {
  position: absolute;
  height: 100%;
  width: 100%;
  content: '';
  background: #7f99c6;
  bottom: 0;
  left: 0;
  z-index: -5;
} */
.dp {

}
.pc {
  cursor: pointer;
  margin: 0 auto;
  width: 312Px;
  height: 112Px;
  background: url('../../assets/img/pc.png');
  background-size: 312Px 112Px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26Px;
  color: #fff;
}
.dp {
  cursor: pointer;
  margin: 0 auto;
  width: 312Px;
  height: 112Px;
  background: url('../../assets/img/dp.png');
  background-size: 312Px 112Px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 26Px;
  color: #fff;
  margin-bottom: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/frame/HeadBar.vue